import React from 'react';
import PropTypes from 'prop-types';
import * as formatter from 'mt-react-common/utils/formatter';
import { Link } from 'react-router-dom';

const ContestListItem = props => (
  <article className="panel-group">
    <div className="panel panel-default panel_padding-adp panel_fullside-xs">
      <div className="panel-heading">
        <div className="media media_table media_padding-adp media_default media_lg">
          <div className="media-left media-middle media-avatar">
            <Link to={`/competition/${props.item.id}`}>
              <span
                className="avatar avatar_bordered avatar_fill"
                style={{
                  backgroundImage: `url(${props.item.prevImageUrl})`
                }}
              />
            </Link>
          </div>

          <div className="media-body media-middle">
            <div className="media-content">
              <div className="media-info">
                <h2
                  className="media-info-name text-overflow"
                  title={props.item.title}
                >
                  <Link to={`/competition/${props.item.id}`}>
                    <span className="media-link">{props.item.title}</span>
                  </Link>
                </h2>
                <div className="media-info-desc visible-xs">
                  <span className="text-success">
                    <i className="fa fa-trophy" /> {props.item.descStatus}
                  </span>
                  &nbsp;{formatter.dateFormat4(props.item.dateFrom)} →{' '}
                  {formatter.dateFormat4(props.item.dateTo)}
                </div>
              </div>
              <div className="media-content-data">
                <Link
                  to={`/competition/${props.item.id}`}
                  className="media-link m-t-4 text-overflow_2lines_all"
                >
                  {props.item.lead}
                </Link>
              </div>
            </div>
          </div>
          <div className="media-right media-middle media-status hidden-xs hidden-sm">
            <div
              className="label label-success label_block label-light"
              data-toggle="tooltip"
              data-container="body"
              data-placement="top"
              title="Проверка, награждение"
            >
              {props.item.descStatus}
            </div>
          </div>
          <div
            className="media-right media-middle w-160 text-center hidden-xs"
            style={{
              width: '200px'
            }}
          >
            <div className="visible-sm">
              <div className="label label-success label_block label-light m-b-4">
                {props.item.descStatus}
              </div>
            </div>
            <div className="media-content text-muted">
              {formatter.dateFormat4(props.item.dateFrom)} →{' '}
              {formatter.dateFormat4(props.item.dateTo)}
            </div>
          </div>
        </div>
      </div>
    </div>
  </article>
);

ContestListItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    lead: PropTypes.string.isRequired,
    prevImageUrl: PropTypes.string.isRequired,
    descStatus: PropTypes.string.isRequired,
    dateFrom: PropTypes.string.isRequired,
    dateTo: PropTypes.string.isRequired
  }).isRequired
};

export default ContestListItem;



// WEBPACK FOOTER //
// ./src/components/Contest/layouts/ContestList/ContestListItem.js